/**
 * Created by JackCui on 2022/5/19
 */

const routerTypeMap = {
  blank: function (params) {
    this.$syRouter.open(params, '_blank')
  },
  replace: function (params) {
    this.$router.replace(params)
  },
  push: function (params) {
    this.$router.push(params)
  }
}

export const linkProps = {}

export const routerPush = function (params) {
  let _params = params
  if (typeof params === 'string') {
    _params = {path: _params}
  }

  const {type = 'push', ...rest} = _params
  const handle = routerTypeMap[type || 'push']
  handle && handle.call(this, rest)
}
